import type { AxiosInstance } from 'axios';

/**
 * Adds request interceptor that attaches ERP spoof headers from localStorage.
 *
 * @param client - Axios instance to add the interceptor to
 * @param prefix - localStorage key prefix (e.g. 'admin' or 'claimflow')
 * @param sessionKey - override localStorage key for the session ID (defaults to `${prefix}_spoofed_session_id`)
 */
export function addSpoofInterceptor(client: AxiosInstance, prefix: string, sessionKey?: string): void {
  client.interceptors.request.use((config) => {
    const spoofedTenantId = localStorage.getItem(`${prefix}_spoofed_tenant_id`);
    if (spoofedTenantId) {
      config.headers['X-Erp-Tenant-Id'] = spoofedTenantId;
    }
    const spoofedBearerToken = localStorage.getItem(`${prefix}_spoofed_bearer_token`);
    if (spoofedBearerToken) {
      config.headers['X-Erp-Bearer-Token'] = spoofedBearerToken;
    }
    const spoofedSessionId = localStorage.getItem(sessionKey ?? `${prefix}_spoofed_session_id`);
    if (spoofedSessionId) {
      config.headers['X-Erp-Session-Id'] = spoofedSessionId;
    }
    return config;
  });
}
